// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as CookieConsentConstants$PorterinCookieConsentManager from "../constants/CookieConsentConstants.mjs";
import * as CookieConsentContentConstants$PorterinCookieConsentManager from "../constants/CookieConsentContentConstants.mjs";

function makePluginConfig(categories, translations, onConsentChangeCallback) {
  return {
          guiOptions: {
            consentModal: {
              layout: CookieConsentConstants$PorterinCookieConsentManager.cloudInline,
              position: CookieConsentConstants$PorterinCookieConsentManager.bottomCenter,
              flipButtons: true,
              equalWeightButtons: true
            },
            preferencesModal: {
              layout: CookieConsentConstants$PorterinCookieConsentManager.box,
              position: CookieConsentConstants$PorterinCookieConsentManager.left,
              flipButtons: false,
              equalWeightButtons: true
            }
          },
          categories: categories,
          language: {
            default: translations.defaultLocale,
            translations: {
              "tr-TR": {
                consentModal: {
                  label: undefined,
                  title: CookieConsentContentConstants$PorterinCookieConsentManager.consentModalTitle,
                  description: CookieConsentContentConstants$PorterinCookieConsentManager.consentModalDescription,
                  acceptAllBtn: CookieConsentContentConstants$PorterinCookieConsentManager.acceptAllBtn,
                  acceptNecessaryBtn: undefined,
                  showPreferencesBtn: CookieConsentContentConstants$PorterinCookieConsentManager.savePreferencesBtn,
                  closeIconLabel: undefined,
                  revisionMessage: undefined,
                  footer: undefined
                },
                preferencesModal: {
                  title: CookieConsentContentConstants$PorterinCookieConsentManager.preferencesModalTitle,
                  acceptAllBtn: CookieConsentContentConstants$PorterinCookieConsentManager.acceptAllBtn,
                  acceptNecessaryBtn: CookieConsentContentConstants$PorterinCookieConsentManager.acceptNecessaryBtn,
                  savePreferencesBtn: CookieConsentContentConstants$PorterinCookieConsentManager.savePreferencesBtn,
                  closeIconLabel: CookieConsentContentConstants$PorterinCookieConsentManager.closeIconLabel,
                  serviceCounterLabel: undefined,
                  sections: [
                    {
                      title: undefined,
                      description: CookieConsentContentConstants$PorterinCookieConsentManager.preferencesModalDescription,
                      linkedCategory: undefined,
                      cookieTable: undefined
                    },
                    {
                      title: CookieConsentContentConstants$PorterinCookieConsentManager.necessaryCookiesTitle,
                      description: CookieConsentContentConstants$PorterinCookieConsentManager.necessaryCookiesDescription,
                      linkedCategory: CookieConsentConstants$PorterinCookieConsentManager.necessary,
                      cookieTable: undefined
                    },
                    {
                      title: CookieConsentContentConstants$PorterinCookieConsentManager.functionalTitle,
                      description: CookieConsentContentConstants$PorterinCookieConsentManager.functionalDescription,
                      linkedCategory: CookieConsentConstants$PorterinCookieConsentManager.functional,
                      cookieTable: undefined
                    },
                    {
                      title: CookieConsentContentConstants$PorterinCookieConsentManager.analyticsAndPerformanceTitle,
                      description: CookieConsentContentConstants$PorterinCookieConsentManager.analyticsAndPerformanceDescription,
                      linkedCategory: CookieConsentConstants$PorterinCookieConsentManager.analytics_and_performance,
                      cookieTable: undefined
                    },
                    {
                      title: CookieConsentContentConstants$PorterinCookieConsentManager.marketingTitle,
                      description: CookieConsentContentConstants$PorterinCookieConsentManager.marketingDescription,
                      linkedCategory: CookieConsentConstants$PorterinCookieConsentManager.marketing,
                      cookieTable: undefined
                    }
                  ]
                }
              }
            }
          },
          onConsent: (function (param) {
              Curry._1(onConsentChangeCallback, undefined);
            }),
          onChange: (function (param) {
              Curry._1(onConsentChangeCallback, undefined);
            })
        };
}

export {
  makePluginConfig ,
}
/* No side effect */
